var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"\n    tw-h-[40px] tw-min-w-[189px] tw-px-4 tw-border tw-rounded-md tw-text-sm\n  ",class:_vm.buttonStyles,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }